import React from 'react';
import PropTypes from 'prop-types';

import Video from 'components/Video';

function VideoWrapper({ media, onReady = () => {}, options = {}, className }) {
  const { video, large, photo_id: mediaId } = media;

  return (
    // TODO: Placeholder for enhanced tag?
    <Video
      mediaId={mediaId}
      options={{
        autoplay: false,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{ src: video }],
        poster: large,
        ...options
      }}
      className={className}
      onReady={onReady}
    />
  );
}

VideoWrapper.propTypes = {
  media: PropTypes.shape({
    photo_id: PropTypes.string,
    video: PropTypes.string,
    type: PropTypes.string,
    large: PropTypes.string
  }).isRequired,
  onReady: PropTypes.func,
  options: PropTypes.shape({}),
  className: PropTypes.string
};

export default VideoWrapper;
